import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';

import {
    fetchSocialActionsByObjective,
    fetchSocialAdSetsByObjective,
    fetchSocialAdsByObjective,
    fetchSocialCampaignsByObjective,
    fetchSocialDataByObjective,
} from 'services/social/duck';
import { withRouter } from 'react-router-dom';
import { SocialObjectiveDashboardComponent } from 'containers/dashboards/DashboardBaseComponent';
import GenericSocialExpandModule from 'components/organisms/social/GenericSocialExpandModule';


class GenericSocialExpandContainer extends SocialObjectiveDashboardComponent {
    constructor(props) {
        super(props, props.objective);
    }

    makeRequestsForData() {
        const entityId = this.getCurrentEntityId();
        const objective = this.getCurrentObjective();
        const payload = this.createPayload(entityId, objective);

        this.props.fetchSocialActionsByObjective(payload);
        this.props.fetchSocialDataByObjective(payload);
        this.props.fetchSocialAdSetsByObjective(payload);
        this.props.fetchSocialAdsByObjective(payload);
        this.props.fetchSocialCampaignsByObjective(payload);
    }

    render() {
        const { hide, showSemCpconv } = this.props;
        return (
            !hide ?
                <GenericSocialExpandModule module={this.props.module}
                    xAxisLabel={this.props.xAxisLabel}
                    backfillBuckets={this.props.backfillBuckets}
                    objective={this.props.objective || this.props.entityObjective}
                    layer={this.props.layer}
                    layerTwo={this.props.layerTwo}
                    showSemCpconv={showSemCpconv}
                    showConversionRevenue={this.props.showConversionRevenue}
                    entityMeta={this.props.entityMeta}
                    entityObjective={this.props.entityObjective}
                    entityObjectiveLabelCode={this.props.entityObjectiveLabelCode}
                /> : null
        );
    }
}

const mapStateToProps = (state, props) => ({
    entityMeta: state.entities.meta,
    module: state.social.facebook.objectives[props.objective],
    layerTwo: state.layerTwo,
    selectedTimeRange: state.config.selectedTimeRange,
    xAxisLabel: get(state, 'config.timeBuckets.config.xAxisLabel', 'Date'),
    backfillBuckets: get(state, 'config.timeBuckets.config.buckets', []),
    showSemCpconv: get(state, 'entities.meta.meta.showSemCpconv', false),
    showConversionRevenue: get(state, 'entities.meta.meta.showConversionRevenue', false),
    entityObjective: get(state, 'entities.meta.meta.programmaticObjective.global', 'ecpa'),
    entityObjectiveLabelCode: get(state, 'entities.meta.meta.programmaticObjective.labelCode', null),
});

export default withRouter(
    connect(mapStateToProps, {
        fetchSocialActionsByObjective,
        fetchSocialAdSetsByObjective,
        fetchSocialAdsByObjective,
        fetchSocialCampaignsByObjective,
        fetchSocialDataByObjective,
    })(GenericSocialExpandContainer));



// WEBPACK FOOTER //
// ./src/containers/dashboards/social/GenericSocialExpandContainer.js